<script setup>

</script>

<template>
  <div class="text-center">
    Created by <a href="https://www.cyberlabllc.com" target="_blank" class="font-semibold">CyberLab</a> &copy; {{ new Date().getFullYear() }} Electride. All Rights Reserved.
  </div>
</template>

<style scoped>

</style>